import { createClient } from "@supabase/supabase-js";

const supabase = createClient(
    "https://woeexpeqouhtojnuyueg.supabase.co",
    "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6IndvZWV4cGVxb3VodG9qbnV5dWVnIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MDcwNTY0MzcsImV4cCI6MjAyMjYzMjQzN30.nreTdyMMF6nP0oiZkpLN-MP5P0tV4roDMDBeHZ_va2Y"
);

export const getReportPatrolService = async (account_uuid, job_type) => {
    let bangkokDate = new Date();

    // หาเวลาเริ่มต้นของวันใน Bangkok
    let startOfDayBangkok = new Date(bangkokDate.setHours(0, 0, 0, 0));
    let endOfDayBangkok = new Date(bangkokDate.setHours(23, 59, 59, 999));

    // แปลงเป็น UTC
    // let startOfDayUTC = new Date(startOfDayBangkok.getTime() - (7 * 60 * 60 * 1000)).toISOString();
    // let endOfDayUTC = new Date(endOfDayBangkok.getTime() - (7 * 60 * 60 * 1000)).toISOString();

    // ดึง site_uuid และ site_name ทั้งหมดที่อยู่ภายใต้ account
    const { data: siteData, error: siteError } = await supabase
        .from("account_site")
        .select("site_uuid, site_name")
        .eq("account_uuid", account_uuid);

    if (siteError) {
        console.error("Error fetching sites:", siteError);
        return [];
    }

    if (!siteData?.length) return [];

    // ดึงข้อมูลจาก site_cycle_jobs และ site_patrol_cycle ที่เกี่ยวข้องกับ job_type และ site_uuid
    const { data: cycleData, error: cycleError } = await supabase
        .from("site_cycle_jobs")
        .select("*")
        .eq("job_type", job_type)
        .gte("created_at", startOfDayBangkok.toISOString())
        .lt("created_at", endOfDayBangkok.toISOString())
        .in("site_uuid", siteData.map(site => site.site_uuid));

    const { data: patrolData, error: patrolError } = await supabase
        .from("site_patrol_cycle")
        .select("*")
        .in("site_uuid", siteData.map(site => site.site_uuid));

    if (cycleError) {
        console.error("Error fetching site cycles:", cycleError);
    }

    if (patrolError) {
        console.error("Error fetching site patrol cycles:", patrolError);
    }

    if (!cycleData.length) return [];

    // ผสานข้อมูล site_name เข้าไปใน combinedData
    const reportData = cycleData.map(item => {
        const site = siteData.find(site => site.site_uuid === item.site_uuid);
        const patrol = patrolData.find(patrol => patrol.id === item.site_cycle_id);
        return {
            ...item,
            site_name: site?.site_name || "",
            start_time: patrol?.start_time || "",
            end_time: patrol?.end_time || "",
        };
    });
    console.log("patrol reportData", reportData);
    // เรียงตาม created_at (ถ้ามี)
    return reportData.sort((a, b) => new Date(b.send_time) - new Date(a.send_time));
};


export const getReportDailyService = async (account_uuid, job_type) => {
    let bangkokDate = new Date();

    // หาเวลาเริ่มต้นของวันใน Bangkok
    let startOfDayBangkok = new Date(bangkokDate.setHours(0, 0, 0, 0));
    let endOfDayBangkok = new Date(bangkokDate.setHours(23, 59, 59, 999));

    // แปลงเป็น UTC
    // let startOfDayUTC = new Date(startOfDayBangkok.getTime() - (7 * 60 * 60 * 1000)).toISOString();
    // let endOfDayUTC = new Date(endOfDayBangkok.getTime() - (7 * 60 * 60 * 1000)).toISOString();


    // ดึง site_uuid และ site_name ทั้งหมดที่อยู่ภายใต้ account
    const { data: siteData, error: siteError } = await supabase
        .from("account_site")
        .select("site_uuid, site_name")
        .eq("account_uuid", account_uuid);

    if (siteError) {
        console.error("Error fetching sites:", siteError);
        return [];
    }

    if (!siteData?.length) return [];

    // ดึงข้อมูลจาก site_cycle_jobs และ site_patrol_cycle ที่เกี่ยวข้องกับ job_type และ site_uuid
    const { data: cycleData, error: cycleError } = await supabase
        .from("site_cycle_jobs")
        .select("*")
        .eq("job_type", job_type)
        // .gte("created_at", startOfDayUTC) // กรองข้อมูลที่สร้างวันนี้ (Bangkok time)
        // .lt("created_at", endOfDayUTC)
        .gte("created_at", startOfDayBangkok.toISOString())
        .lt("created_at", endOfDayBangkok.toISOString())
        .in("site_uuid", siteData.map(site => site.site_uuid));

    const { data: patrolData, error: patrolError } = await supabase
        .from("site_report_cycle")
        .select("*")
        .in("site_uuid", siteData.map(site => site.site_uuid));

    if (cycleError) {
        console.error("Error fetching site cycles:", cycleError);
    }

    if (patrolError) {
        console.error("Error fetching site patrol cycles:", patrolError);
    }

    if (!cycleData.length) return [];

    // ผสานข้อมูล site_name เข้าไปใน combinedData
    const reportData = cycleData.map(item => {
        const site = siteData.find(site => site.site_uuid === item.site_uuid);
        const patrol = patrolData.find(patrol => patrol.id === item.site_cycle_id);
        return {
            ...item,
            site_name: site?.site_name || "",
            report_time: patrol?.report_time || "",
        };
    });

    console.log("reportData", reportData);
    // เรียงตาม created_at (ถ้ามี)
    return reportData.sort((a, b) => new Date(b.send_time) - new Date(a.send_time));
};


export const toggleAcknowledgeReportPatrolService = async (id) => {
    // Fetch current value
    const { data: currentData, error: fetchError } = await supabase
        .from("site_patrol_report")
        .select("acknowledge")
        .eq("id", id)
        .single();

    if (fetchError) {
        console.error("Error fetching data:", fetchError);
        return;
    }

    // Toggle the value
    const newValue = !currentData.acknowledge;

    // Update the value
    const { data, error } = await supabase
        .from("site_patrol_report")
        .update({ acknowledge: newValue })
        .eq("id", id);

    if (error) {
        console.error("Error updating data:", error);
    } else {
        console.log("Updated successfully:", data);
    }
};


export const updateReportPatrolService = async (id, metadata) => {
    const { data, error } = await supabase
        .from("site_patrol_report")
        .update({ metadata: metadata })
        .eq("id", id);
};


export const deleteReportService = async (id) => {
    const { data, error } = await supabase
        .from("site_patrol_report")
        .delete()
        .eq("id", id);
};
